import { api } from "api/api";
import { CONTEXT_TYPES } from "./get-book-appointment-dashboard-items";
import dayjs from "dayjs";

export type Params = {
    doctorId?: string;
    typeId?: string;
    date: string;
    context: CONTEXT_TYPES;
    contextId: string;
}

 export default async function getAvailableTimeSlots({ context, contextId, typeId, doctorId, date }: Params) {
    const url = 'api/public/book/appointment/online/available/slots';
    const formattedDate = date.replace("+00:00", "");

    const response = await api.get(url, {
        params: {
            typeId,
            doctorId,
            date: formattedDate,
            context,
            contextId,
        }
    });
    return response.data.data;
};
